(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["visual-navigation-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("click", async function(e) {
    const visual_nav_link = e.target.closest(".visual-navigation__image-link, .visual-navigation__text-link");
    if(visual_nav_link) {
      let curr_link_url = visual_nav_link.getAttribute("href");
      let links_main_par = visual_nav_link.closest(".visual-navigation-wrapper").querySelectorAll(".visual-navigation__list-item");
      let text_list = visual_nav_link.closest(".visual-navigation__list-item");
      links_main_par.forEach(i => {
        if(i == text_list){
          i.querySelector(".visual-navigation__text-link").classList.add("active");
        }else{
          i.querySelector(".visual-navigation__text-link").classList.remove("active");
        }
      });
      let target_sections = document.querySelectorAll("section.section--image-with-text-slideshow");
      if(curr_link_url === "#"){
        e.preventDefault();
        let target_title = visual_nav_link.getAttribute("aria-label");
        if(target_title){
          target_sections.forEach(i => {
            let hide_section = true;
            let section_titles = i.querySelector(".iwts-navigation-target-titles");
            if(!cn(section_titles)){
              section_titles = section_titles.textContent.split(",");
              for(let t=0;t<section_titles.length;t++){
                let curr_title = section_titles[t].trim();
                if(target_title == curr_title){
                  hide_section = false;
                  break;
                }
              }
              if(hide_section){
                i.classList.add("hide")
              }else{
                i.classList.remove("hide");
              }
            }
          })
        }
      }else if(curr_link_url === "#all"){
        e.preventDefault();
        target_sections.forEach(i => {
          i.classList.remove("hide");
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
